module.exports = __webpack_public_path__ + "media/img/pages/companies/ruag-790e8f0b3f301e6204b91e5cc5dddd86.png";